module.exports = __webpack_public_path__ + "static/media/mrLegend.ce5238ae.webp";